export default __webpack_public_path__ + "static/media/AcuraBG.eefa95d8.png";